import { invokeApi } from "../../bl_libs/invokeApi";

const getAuthHeader = () => ({
  "x-sh-auth": localStorage.getItem("token"),
});

// ============ Job Postings ============

export const get_job_postings_api = async () =>
  invokeApi({
    path: "api/admin/careers/jobs",
    method: "GET",
    headers: getAuthHeader(),
  });

export const create_job_posting_api = async (data) =>
  invokeApi({
    path: "api/admin/careers/jobs",
    method: "POST",
    headers: getAuthHeader(),
    postData: data,
  });

export const update_job_posting_api = async (jobId, data) =>
  invokeApi({
    path: `api/admin/careers/jobs/${jobId}`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: data,
  });

export const delete_job_posting_api = async (jobId) =>
  invokeApi({
    path: `api/admin/careers/jobs/${jobId}`,
    method: "DELETE",
    headers: getAuthHeader(),
  });

// ============ Applications ============

export const get_applications_api = async (params = {}) =>
  invokeApi({
    path: "api/admin/careers/applications",
    method: "GET",
    headers: getAuthHeader(),
    queryParams: params,
  });

export const get_application_api = async (appId) =>
  invokeApi({
    path: `api/admin/careers/applications/${appId}`,
    method: "GET",
    headers: getAuthHeader(),
  });

export const update_application_status_api = async (appId, status) =>
  invokeApi({
    path: `api/admin/careers/applications/${appId}/status`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: { status },
  });

export const add_application_note_api = async (appId, text) =>
  invokeApi({
    path: `api/admin/careers/applications/${appId}/notes`,
    method: "POST",
    headers: getAuthHeader(),
    postData: { text },
  });